import React from 'react'
import Link from 'next/link'
import { Button, Row } from 'antd'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { CustomCol, PageTitle, GoBackLink } from 'src/components'
import styles from './IntegrationDetailsHeaderContent.module.scss'
import { SettingOutlined, UnorderedListOutlined } from '@ant-design/icons'

const IntegrationDetailsHeaderContent: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useRouter().query

  return (
    <Row>
      <CustomCol>
        <PageTitle>
          <GoBackLink link='/developers' />
        </PageTitle>
      </CustomCol>
      <CustomCol >
        <Link href={`/developers/integration-settings/?id=${id}`} passHref>
          <Button
            className={styles.buttonSettings}
            size='large'
            shape='round'
            icon={<SettingOutlined />}
          >
            {t('menuItems.Settings')}
          </Button>
        </Link>

        <Link href={`/developers/integration-projects/?id=${id}`} passHref>
          <Button
            className={styles.buttonProjects}
            size='large'
            shape='round'
            icon={<UnorderedListOutlined />}
          >
            {t('footer.projects')}
          </Button>
        </Link>
      </CustomCol>
    </Row>
  )
}

export default IntegrationDetailsHeaderContent
